function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a7a9ac;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Facebook_icon");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M295.35,130.71H257.6a7,7,0,0,0-7,7v37.75a7,7,0,0,0,7,7h18.62l0-18.47h-4.8a1.13,1.13,0,0,1-1.13-1.13l0-6a1.13,1.13,0,0,1,1.13-1.14h4.79V150c0-6.68,4.08-10.31,10-10.31h4.89a1.13,1.13,0,0,1,1.13,1.13v5a1.13,1.13,0,0,1-1.13,1.13h-3c-3.24,0-3.87,1.54-3.87,3.8v5h7.12a1.13,1.13,0,0,1,1.12,1.27l-0.71,6a1.13,1.13,0,0,1-1.12,1h-6.38l0,18.47h11.08a7,7,0,0,0,7-7V137.68A7,7,0,0,0,295.35,130.71Z",
  transform: "translate(-250.64 -130.71)"
});

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 51.68 51.68",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.c109dfee.svg";
export { ForwardRef as ReactComponent };